export default __webpack_public_path__ + "twoColumnContentComponent.3c9011608f917efcbbe4bc17b5cfd0bf.png";